const initialState = {
  apiBaseUrl: 'unknown',
  environment: 'unknown',
  isLoading: false,
};

const EnvironmentReducer = (state = initialState, action) => {
  if (action.type === 'GET_TPP_WEB_ENVIRONMENT_SUCCESS') {
    return {
      ...state,
      ...action.data.environmentVariables,
    };
  }
  return state;
};

export default EnvironmentReducer;
